import {
  BabyIcon,
  CakeIcon,
  ClipboardCheckIcon,
  DotIcon,
  FileTextIcon,
  GavelIcon,
  MailQuestionMarkIcon,
  PillBottleIcon,
  SproutIcon,
  StethoscopeIcon,
} from 'lucide-react'

import { ExtendedTimelineEvent } from '@/components/organisms/timeline/timeline-vertical'

import { Document } from '../../../../../backend/payload/payload-types'

export const getDocumentIcon = (type: Document['type']) => {
  switch (type) {
    case 'certificate':
    case 'report':
      return ClipboardCheckIcon
    case 'decision':
      return GavelIcon
    case 'diagnosis':
      return StethoscopeIcon
    case 'prescription':
      return PillBottleIcon
    case 'application':
      return MailQuestionMarkIcon
    case 'document':
    case 'unknown':
    default:
      return FileTextIcon
  }
}

export const getTimelineEventIcon = (type: ExtendedTimelineEvent['type']) => {
  switch (type) {
    case 'certificate':
    case 'report':
      return ClipboardCheckIcon
    case 'application':
      return MailQuestionMarkIcon
    case 'birth':
      return BabyIcon
    case 'birthday':
      return CakeIcon
    case 'decision':
      return GavelIcon
    case 'diagnosis':
      return StethoscopeIcon
    case 'prescription':
      return PillBottleIcon
    case 'document':
      return FileTextIcon
    case 'life-event':
      return SproutIcon
    case 'unknown':
    default:
      return DotIcon
  }
}
